import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

import './services/firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'loaders.css/loaders.css';
import 'video-react/dist/video-react.css';

Sentry.init({
  dsn: 'https://806657bfe031436eb6655f67c6b4449f@sentry.io/1805135',
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
